var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2666_11752)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 5.07227,
    width: 1.05003,
    height: 7.7919,
    rx: 0.525016,
    fill: "#63666A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5.07227,
    width: 1.05003,
    height: 7.7919,
    rx: 0.525016,
    fill: "#63666A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53592 2.30078H9.26556C9.3775 2.30078 9.48085 2.33757 9.56418 2.39971H6.23731C6.32064 2.33757 6.42399 2.30078 6.53592 2.30078ZM4.53703 2.73361C4.57245 1.66014 5.45383 0.800781 6.53592 0.800781H9.26556C10.3477 0.800781 11.229 1.66014 11.2645 2.73361H11.874H13.6161C13.9388 2.73361 14.2005 2.99526 14.2005 3.31801C14.2005 3.64076 13.9388 3.9024 13.6161 3.9024H12.874V14.2007C12.874 14.7529 12.4263 15.2007 11.874 15.2007H3.92631C3.37403 15.2007 2.92631 14.7529 2.92631 14.2007V3.9024H2.18449C1.86174 3.9024 1.6001 3.64076 1.6001 3.31801C1.6001 2.99526 1.86174 2.73361 2.18449 2.73361H3.92631H4.53703ZM4.42631 4.23361V13.7007H11.374V4.23361H4.42631Z",
    fill: "#63666A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2666_11752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconGray);
export default __webpack_public_path__ + "static/media/trash_icon_gray.b62cf3ca16760435d408e2c7d5c2282e.svg";
export { ForwardRef as ReactComponent };